module.exports = __webpack_public_path__ + "static/media/linkCard_rates.ba54424a.svg";